import MessageBaseController from '../common/message.base.controller'

class MessageCreateController extends MessageBaseController {
  /*@ngInject*/
  constructor(Auth, $state, User, MessageService, Modal, $translate, $stateParams, UserService, LanguageService) {

    super(Auth, $state, User, MessageService, Modal, $translate, $stateParams);

    this.LanguageService = LanguageService;

    this.message = 'Message create';
    this.languages = [];
    this.messageTypes = [];
    this.loggedInUser = this.User.getUser();

    this.loading = false;

    this.model = {
     defaultSelection : false
    };
    this.branchId = this.User.getUser().branchId;

  }

  reset() {
    for (let key in this.model) {
      this.model[key] = "";
      this.clearErrors();
    }
    this.model.description = {};
  }

  $onInit() {
    // this.reset();
    this.model.description = {};
    this.LanguageService.all()
      .then((response) => {
        this.languages = response.results;

        this.languages.map((language) => {
          this.model.description[language.id] = '';
        });
      });

    this.types = ['M', 'T', 'R', 'SM', 'NP', 'UI', 'H', 'D_R', 'CNT', 'D_CNT', 'NDR', 'IM', 'DS'];
    this.messageTypes = this.types.map((type) => {
      return {
        label: type + ' | ' + this.$translate.instant(`message.types.${type}`),
        value: type
      };
    });
  }

  submit() {
    this.loading = true;

    this.Service.create(this.loggedInUser.languageId, this.model, this.branchId)
      .then((response) => {
        this.askCreate();
      })
      .catch((err) => {
        if (err && err.data && err.data.errors && err.data.errors.length) {
          err.data.errors.map((e) => {
            this.errorMessage += e.message + '<br/>';
          });
        }
        else {
          console.error(err);
        }
      })
      .finally(() => {
        this.loading = false;
      });
  }
}

export default MessageCreateController;



// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/message/create/message.create.controller.js